import { UrlConstants } from "../url.constants";
export class ApiBuildingPlansConstants {
    static URL = UrlConstants.API_V2 + "BuildingPlans";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBuildingPlansApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateBuildingPlansInvoiceReport";
    static FUNCTION_SET_PROFESSIONAL_BODIES = "SetBuildingPlansProfessionalBodies";
    static FUNCTION_SET_PROPERTIES = "SetBuildingPlansProperties";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetBuildingPlansRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER = "VerifyResubmissionReferenceNumber";
}
